import AuthLayout from '@/components/auth/auth-layout';
import { DesktopLoginLayout } from '@/components/auth/desktop-login-layout';
import { isDesktopPlatform } from '@/lib/desktop/bridge';

import type { ReactNode } from 'react';

interface AuthRouteLayoutProps {
  readonly children: ReactNode;
}

/** Picks the shell for whichever app is hosting the auth route. */
export function AuthRouteLayout({ children }: AuthRouteLayoutProps) {
  return isDesktopPlatform() ? (
    <DesktopLoginLayout>{children}</DesktopLoginLayout>
  ) : (
    <AuthLayout>{children}</AuthLayout>
  );
}
